import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonDemoButtonComponent from 'webapp/components/common/demo-button';

import type { AnyFilterSort } from 'webapp/models-custom/filter-sort/base';

interface Args {
	model: AnyFilterSort;
	showDemoButton?: boolean;
	entityName?: string;
}

interface FilterNoResultsComponentInterface<T> {
	Args: T;
}

export default class FilterNoResultsComponent extends Component<
	FilterNoResultsComponentInterface<Args>
> {
	@service('account') declare accountService: Service.Account;

	get isVisible(): boolean {
		const model = this.args.model;

		return (
			model.noResults &&
			(model.isSearchActive || model.isAnyFilterActive || model.isRecentlyDeletedSelected)
		);
	}

	get isRecentlyDeletedEmptyState(): boolean {
		const model = this.args.model;

		return (
			model.isRecentlyDeletedSelected &&
			model.noResults &&
			!model.isSearchActive &&
			!!this.args.entityName
		);
	}

	@action
	resetFilters(): void {
		this.args.model.resetFilters();
	}
	<template>
		{{#if this.isVisible}}
			<div class="noResults">
				{{#if this.isRecentlyDeletedEmptyState}}
					No recently deleted
					<span>{{@entityName}}</span>
				{{else}}
					{{{@model.safeNoResultsText}}}
				{{/if}}
				{{#if @model.isAnyFilterActive}}
					<a role="button" {{on "click" this.resetFilters}}>Reset filter</a>
				{{/if}}
			</div>

			{{#if @showDemoButton}}
				<CommonDemoButtonComponent @trackingOrigin="onboarding_search" />
			{{/if}}
		{{/if}}
	</template>
}
